module.exports = __webpack_public_path__ + "SP_NarratorVideo_2-51dc91969fe48a7b9eb0cd127230d9dc.png";